import styled from "styled-components";
import { useState, useEffect } from "react";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../components/FormControls/SecondaryButton";
import request from "../../../../../api/request";
import Grid from "../../../../../components/Grid";
import NarrowGrid from "../../../../../components/NarrowGrid";
import FormStringInput from "../../../../../components/FormControls/FormStringInput";
import FormSelectWithLabel from "../../../../../components/FormControls/FormSelectWithLabel";
import FormNumberInputNoSpinner from "../../../../../components/FormControls/FormNumberInputNoSpinner";
import { NotificationManager } from 'react-notifications';

const StyledAccountTypes = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 750px;
    box-sizing: border-box;
    min-height: 526px;
    padding: 30px;
    margin-bottom: 30px;
    margin-left: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

const Note = styled.span`
    font-size: 9px;
    color: ${(props) => props.theme.color.gray};
    font-weight: 600;
`;

function AccountTypes(props) {

    let currentYear = new Date().getFullYear();

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeletingAccountType, setIsDeletingAccountType] = useState(false);
    const [accountTypes, setAccountTypes] = useState([]);
    const [selectedAccountType, setSelectedAccountType] = useState(null);
    const [selectedAccountTypeId, setSelectedAccountTypeId] = useState(null);
    const [isAddAccountTypeMode, setIsAddAccountTypeMode] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Number', type: 'String', width: 100, textAlign: 'center'},
        {id: 'Description', type: 'String', width: 200, textAlign: 'left'},
    ]);
    const [gridData, setGridData] = useState({groups: ['Type: Branches', 'Type: Sub-branches'], items: [[], []]});

    const [recordType, setRecordType] = useState(1);
    const [accountingYear, setAccountingYear] = useState(props.baseYear);
    const [fundTypeName, setFundTypeName] = useState('');
    const [fundTypeCode, setFundTypeCode] = useState('');
    const [tableID, setTableID] = useState(1);
    const [restrictedFunds, setRestrictedFunds] = useState(false);
    
    const [needsValidation, setNeedsValidation] = useState(false);
    const [isAddingDuplicatedAccountType, setIsAddingDuplicatedAccountType] = useState(false);
    
    let years = [];
    for (let i = currentYear - 10; i < currentYear + 5; i ++) {
        years.push(i);
    }

    let branchTypes = ['Branch', 'Sub-Branch'];
    const branchTypeStringToInt = (branchTypeStr) => {
        if (branchTypeStr === 'Branch') {
            return 1;
        } else {
            return 2;
        }
    }
    const onChangeRecordType = (e) => {
        let bType = branchTypeStringToInt(e.target.value);
        setRecordType(bType);
    }

    const onSelectGridItem = (item) => {
        setSelectedAccountTypeId(item.Id);
        setSelectedAccountType(item);
    }
    
    const fetchFundTypes = async (recordTypeToSelect, fundTypeCodeToSelect) => {
        try {
            let accountTypeList = [];

            const resp = (await request('database', 'fetchFundTypes'));
            if (resp.ok) {
                resp.data.map((accountType, index) => {
                    accountTypeList.push(accountType);
                });
                setAccountTypes(accountTypeList);
                rebuildGridData(accountTypeList, recordTypeToSelect, fundTypeCodeToSelect);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch fund types: ', e);
            return false;
        }
        return true;
    }

    const onChangeSortId = (val) => {
        setTableID(parseInt(val));
    }

    const onDeleteFundType = async () => {
        if (selectedAccountType) {
            setIsDeletingAccountType(true);
            let deleteData = {};
            deleteData.RecordType = selectedAccountType.RecordType;
            deleteData.AccountingYear = selectedAccountType.AccountingYear;
            deleteData.FundTypeCode = selectedAccountType.FundTypeCode;
            
            const resp = (await request('database', 'deleteFundType', [deleteData]));
            if (resp.ok) {
                setSelectedAccountType(null);
                setSelectedAccountTypeId(null);
                fetchFundTypes();
                NotificationManager.success('Successfully deleted account type');
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDeletingAccountType(false);
        }
    }

    const onSaveChanges = async () => {
        if (isAddAccountTypeMode) { // adding new item
            if (fundTypeName === '' || fundTypeCode === null || tableID < 1 || tableID > 9) {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (accountTypes.length > 0 && (accountTypes.find((itm) => itm.RecordType === recordType && itm.AccountingYear === accountingYear && (itm.TableID === tableID || itm.FundTypeCode.replace(/\s/g, '') === fundTypeCode)))) {
                    setIsAddingDuplicatedAccountType(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = recordType;
                    saveData.AccountingYear = accountingYear;
                    saveData.FundTypeName = fundTypeName;
                    saveData.FundTypeCode = fundTypeCode;
                    saveData.TableID = tableID;
                    saveData.RestrictedFunds = restrictedFunds;

                    const resp = (await request('database', 'createFundType', [saveData]));
                    if (resp.ok) {
                        fetchFundTypes(recordType, fundTypeCode);
                        NotificationManager.success('Successfully added fund type');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddAccountTypeMode(false);
                }
            }
        } else {
            if (fundTypeName === '' || fundTypeCode === null || tableID < 1 || tableID > 9) {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (accountTypes.length > 0 && (accountTypes.find((itm) => (itm.RecordType !== selectedAccountType.RecordType || itm.AccountingYear !== selectedAccountType.AccountingYear || itm.FundTypeCode !== selectedAccountType.FundTypeCode) && itm.RecordType === recordType && itm.AccountingYear === accountingYear && (itm.TableID === tableID || itm.FundTypeCode.replace(/\s/g, '') === fundTypeCode)))) {
                    setIsAddingDuplicatedAccountType(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = recordType;
                    saveData.AccountingYear = accountingYear;
                    saveData.FundTypeName = fundTypeName;
                    saveData.FundTypeCode = fundTypeCode;
                    saveData.TableID = tableID;
                    saveData.RestrictedFunds = restrictedFunds;

                    saveData.OldRecordType = selectedAccountType.RecordType;
                    saveData.OldAccountingYear = selectedAccountType.AccountingYear;
                    saveData.OldFundTypeCode = selectedAccountType.FundTypeCode;

                    const resp = (await request('database', 'updateFundType', [saveData]));
                    if (resp.ok) {
                        fetchFundTypes(recordType, fundTypeCode);
                        NotificationManager.success('Successfully updated fund type');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddAccountTypeMode(false);
                }
            }
        }
    }

    const rebuildGridData = (accountTypes, recordTypeToSelect, fundTypeCodeToSelect) => {
        if (accountTypes && accountTypes.length > 0) {
            let accountTypesBranch = [];
            let accountTypesSubBranch = [];
            accountTypes.map((accountType, index) => {
                if (accountType.AccountingYear === props.baseYear) {
                    let gridItem = {Id: index, Number: accountType.FundTypeCode, Description: accountType.FundTypeName, ...accountType};
                    if (accountType.RecordType === 1) {
                        accountTypesBranch.push(gridItem);
                    } else {
                        accountTypesSubBranch.push(gridItem);
                    }
                    if (recordTypeToSelect && fundTypeCodeToSelect && accountType.RecordType === recordTypeToSelect && accountType.FundTypeCode === fundTypeCodeToSelect) {
                        setSelectedAccountTypeId(index);
                        setSelectedAccountType(gridItem);
                    }
                }
            });
            setGridData({groups: ['Type: Branches', 'Type: Sub-branches'], items: [accountTypesBranch, accountTypesSubBranch]});
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            props.setPageTitle('Account types');
            fetchFundTypes();
            setLoadedPage(true);
        }

        rebuildGridData(accountTypes);

        setRecordType(1);
        setAccountingYear(props.baseYear);
        setFundTypeName('');
        setFundTypeCode('');
        setTableID(1);
        setRestrictedFunds(false);

        setSelectedAccountType(null);
        setSelectedAccountTypeId(null);
        setNeedsValidation(false);
    }, [props.baseYear]);

    useEffect(() => {
        if (isAddAccountTypeMode) {
            setNeedsValidation(false);
            setRecordType(1);
            setAccountingYear(props.baseYear);
            setFundTypeName('');
            setFundTypeCode('');
            setTableID(1);
            setRestrictedFunds(false);
        } else if (selectedAccountType) {
            setNeedsValidation(false);
            setRecordType(selectedAccountType.RecordType);
            setAccountingYear(selectedAccountType.AccountingYear);
            setFundTypeName(selectedAccountType.FundTypeName);
            setFundTypeCode(selectedAccountType.FundTypeCode);
            setTableID(selectedAccountType.TableID);
            setRestrictedFunds(selectedAccountType.RestrictedFunds);
        }
    }, [isAddAccountTypeMode]);

    useEffect(() => {
        if (selectedAccountType) {
            setRecordType(selectedAccountType.RecordType);
            setAccountingYear(selectedAccountType.AccountingYear);
            setFundTypeName(selectedAccountType.FundTypeName);
            setFundTypeCode(selectedAccountType.FundTypeCode);
            setTableID(selectedAccountType.TableID);
            setRestrictedFunds(selectedAccountType.RestrictedFunds);
        } else {
            setNeedsValidation(false);
            setRecordType(1);
            setAccountingYear(props.baseYear);
            setFundTypeName('');
            setFundTypeCode('');
            setTableID(1);
            setRestrictedFunds(false);
        }
    }, [selectedAccountType]);

    useEffect(() => {
        setIsAddingDuplicatedAccountType(false);
    }, [recordType, accountingYear, fundTypeCode]);

    useEffect(() => {
        setIsAddingDuplicatedAccountType(false);
        setNeedsValidation(false);
    }, [props.baseYear, selectedAccountType, isAddAccountTypeMode]);

    return (
        <StyledAccountTypes>
            <WhiteBoard>
                <div style={{display:'flex'}}>
                    <div>
                        <NarrowGrid id='systemstructure_accounttypes_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddAccountTypeMode} itemIdToSelect={selectedAccountTypeId} onSelectGridItem={onSelectGridItem} gridStyle={{width:300, height:400}}></NarrowGrid>
                        <div style={{marginTop:20}}>
                            {selectedAccountType && !isAddAccountTypeMode && <SecondaryButton caption='Delete' isLoading={isDeletingAccountType} onClick={() => onDeleteFundType()} style={{width:75, height:25}}></SecondaryButton>}
                            {isAddAccountTypeMode && <SecondaryButton caption='Cancel' onClick={() => setIsAddAccountTypeMode(false)} style={{width:75, height:25, float:'right'}}></SecondaryButton>}
                            {!isAddAccountTypeMode && <PrimaryButton caption='Create new' onClick={() => setIsAddAccountTypeMode(true)} style={{width:100, height:25, float:'right'}}></PrimaryButton>}
                        </div>
                    </div>
                    <div style={{marginLeft:30}}>
                        <div style={{display:'flex'}}>
                            <FormSelectWithLabel label='Type' items={branchTypes} value={branchTypes[recordType-1]} disabled={!isAddAccountTypeMode && !selectedAccountType} onChange={(e) => onChangeRecordType(e)} style={{width:220, height:35, paddingLeft:10}} selectStyle={{paddingTop:0}}></FormSelectWithLabel>
                            <FormSelectWithLabel label='Year' items={years} value={accountingYear} disabled={!isAddAccountTypeMode && !selectedAccountType} onChange={(e) => setAccountingYear(parseInt(e.target.value))} style={{width:100, height:35, paddingLeft:10, marginLeft:30}} selectStyle={{paddingTop:0}} labelStyle={{marginLeft:30}}></FormSelectWithLabel>
                        </div>
                        
                        <FormStringInput label='Description' value={fundTypeName} disabled={!isAddAccountTypeMode && !selectedAccountType} onChange={(val) => setFundTypeName(val)} inputStyle={{width:220}}></FormStringInput>
                        <FormStringInput label='Code' value={fundTypeCode} disabled={!isAddAccountTypeMode && !selectedAccountType} onChange={(val) => setFundTypeCode(val)} inputStyle={{width:100}}></FormStringInput>
                        
                        <FormNumberInputNoSpinner label='Sort ID' value={tableID} disabled={!isAddAccountTypeMode && !selectedAccountType} validated={needsValidation && (tableID < 1 || tableID > 9) ? false : undefined} onChange={(val) => onChangeSortId(val)} inputStyle={{width:220, height:35}} style={{marginTop:15}}></FormNumberInputNoSpinner>
                        <Note style={{marginTop:5}}>Enter a number from 1 to 9</Note>
                        {isAddingDuplicatedAccountType && <div style={{marginTop:75, width:280, fontSize:12, fontWeight:700, color:'#dc3545'}}>* Code or Sort ID is duplicated.</div>}
                    </div>
                </div>
            </WhiteBoard>
            <div>
                <PrimaryButton caption={isAddAccountTypeMode ? 'Add account type' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} disabled={isAddAccountTypeMode || selectedAccountType ? false : true} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
        </StyledAccountTypes>
    )
}

export default AccountTypes;